import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  expertName: {
    id: 'studio.EeE8+D',
    defaultMessage: 'Expert name',
  },
  expertDescription: {
    id: 'studio.tg9/Lr',
    defaultMessage: 'Expert description',
  },
  expertPhoto: {
    id: 'studio.wxKWWa',
    defaultMessage: 'Expert photo',
  },
  headerImage: {
    id: 'studio.mmQuQM',
    defaultMessage: 'Header image',
  },
  markdownTips: {
    id: 'studio.vhBxKa',
    defaultMessage:
      'You can use {markdownLink} to format your description. To upload images, use a service like {imageHostingLink}.',
  },
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  noFile: {
    id: 'studio.KWwyi1',
    defaultMessage: 'No file selected',
  },
  private: {
    id: 'studio.viXE32',
    defaultMessage: 'Private',
  },
  privateExplanation: {
    id: 'studio.mBPNep',
    defaultMessage: 'Hide this app collection from the public list',
  },
  sslError: {
    id: 'studio.0gbG2D',
    defaultMessage: 'There was a problem generating an SSL certificate for this domain',
  },
  sslUnknown: {
    id: 'studio.XpziH6',
    defaultMessage: 'The current status of the SSL certificate is unknown',
  },
  sslMissing: {
    id: 'studio.ssWhHg',
    defaultMessage:
      'The SSL certificate is missing. If this persists, try updating this field an changing it back.',
  },
  sslReady: {
    id: 'studio.Fu7y9h',
    defaultMessage: 'Your app collection is secured using SSL',
  },
  sslPending: {
    id: 'studio.oBSs4o',
    defaultMessage:
      'Your SSL certificate is being generated. This may take up to 24 hours, but it’s usually faster.',
  },
  domain: {
    id: 'studio.bC8rRP',
    defaultMessage: 'Domain name',
  },
  domainError: {
    id: 'studio.9Jktf3',
    defaultMessage: 'This must be a valid domain name without a protocol',
  },
  domainDescription: {
    id: 'studio.vonwx2',
    defaultMessage:
      'The domain name on which this app collection is available. For more information on how to set this up, please refer to the <link>documentation</link>.',
  },
});
